import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { Directive, Input } from '@angular/core';

/**
 * Validate the min number of a `input[type=text]`.
 * Number fields cannot be used because we can’t force English decimal point on them.
 */
@Directive({
    selector: '[pkpMinNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MinNumberValidatorDirective,
            multi: true
        }
    ]
})
export class MinNumberValidatorDirective implements Validator {
    @Input('pkpMinNumberValidator') subject: number;

    validate(control: AbstractControl): ValidationErrors | null {
        try {
            return control.value >= this.subject
                ? null
                : { pkpMinNumberValidator: { value: control.value } };
        } catch (e) {
            return null;
        }
    }
}
